import React from 'react';

export const TerminalReading = () => {
  return <>Em Desenvolvimento</>;
};
